//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
// import Swiper from 'swiper';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import { mapGetters,mapActions,mapState } from 'vuex';


import { Toast, PullRefresh,Empty} from 'vant';

export default {
 name: 'home',
 data(){
    let that = this
  return {
      value:'',
      active:1,
      activeD:1,
      current:2
    }
 },

 computed:{

 },
  methods:{
      addC(params){
          this.active = params
      },
            addD(params){
          this.activeD = params
      },
      itemRender(current, type, originalElement) {
          if (type === 'prev') {
            return null;
          } else if (type === 'next') {
            return null;
          }
          
          return originalElement;
        },
  },
  mounted(){
    
  },
  created(){
     
  },
 
}



// WEBPACK FOOTER //
// ./src/pages/zTree/zTree.vue